<template>
  <b-sidebar
    :id="drawer.id"
    :title="drawerTitle"
    backdrop-variant="dark"
    backdrop
    right
    shadow
    no-close-on-backdrop
    no-close-on-esc
    width="620px"
    :visible="drawer.visible"
    sidebar-class="right-drawer white-drawer"
    aria-hidden="false"
    @hidden="onClose"
    @shown="handleDrawerShown"
  >
    <div class="p-2">
      <ValidationObserver
        ref="formObserver"
        #default="{ invalid }"
      >
        <section class="mb-[2rem]">
          <!-- Header title for Form Data Talent section if Ganti Talent -->
          <div
            v-if="isGantiTalentMode"
            class="mb-[1.5rem]"
          >
            <p class="font-semibold text-lg text-black mb-0">
              Form Data Talent
            </p>
          </div>

          <div class="space-y-[.75rem]">
            <!-- GANTI PARTNER Specific fields: Nama Partner Awal & Pilih Partner Baru -->
            <div
              v-show="isGantiPartnerMode"
              class="space-y-[.75rem]"
            >
              <BFormGroup
                label="Nama Partner Awal"
                class="text-black font-medium"
              >
                <template #label>
                  Nama Partner Awal<span class="text-danger">*</span>
                </template>
                <BFormInput
                  v-model="form.initialPartnerName"
                  :disabled="true"
                />
              </BFormGroup>

              <BFormGroup class="text-black font-medium">
                <template #label>
                  Pilih Partner Baru<span class="text-danger">*</span>
                </template>
                <ValidationProvider
                  #default="{ errors }"
                  name="Pilih Partner Baru"
                  :rules="isGantiPartnerMode ? 'required' : ''"
                >
                  <v-select
                    v-model="form.newPartner"
                    label="name"
                    :options="listPartner"
                    :loading="isLoadingPartners"
                    placeholder="Cari partner"
                    @search="(search) => search.length > 0 ? onSearchPartner(search) : ''"
                    @input="() => {
                      listDevice = []
                      getListDevice()
                    }"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </ValidationProvider>
              </BFormGroup>
            </div>

            <!-- GANTI TALENT Row 1: Side by side Nama Talent & Layanan (Existing) -->
            <div
              v-if="isGantiTalentMode"
              class="flex gap-[.75rem]"
            >
              <BFormGroup class="text-black font-medium w-full mb-0">
                <template #label>
                  Nama Talent
                </template>
                <BFormInput
                  v-model="form.talentName"
                  :disabled="true"
                />
              </BFormGroup>
              <BFormGroup class="text-black font-medium w-full mb-0">
                <template #label>
                  Layanan
                </template>
                <BFormInput
                  v-model="form.serviceName"
                  :disabled="true"
                />
              </BFormGroup>
            </div>

            <!-- GANTI TALENT Row 2: Side by side Nama Talent Baru & Layanan Baru -->
            <div
              v-show="isGantiTalentMode"
              class="flex gap-[.75rem]"
            >
              <BFormGroup class="text-black font-medium w-full mb-0">
                <template #label>
                  Nama Talent Baru<span class="text-danger">*</span>
                </template>
                <ValidationProvider
                  #default="{ errors }"
                  name="Nama Talent Baru"
                  :rules="isGantiTalentMode ? 'required' : ''"
                >
                  <v-select
                    v-model="form.newTalent"
                    label="full_name"
                    :options="listTalent"
                    :loading="isLoadingTalents"
                    :disabled="!form.newService"
                    placeholder="Cari talent"
                    @search="(search) => search.length > 0 ? onSearchTalent(search) : ''"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </ValidationProvider>
              </BFormGroup>

              <BFormGroup class="text-black font-medium w-full mb-0">
                <template #label>
                  Layanan<span class="text-danger">*</span>
                </template>
                <ValidationProvider
                  #default="{ errors }"
                  name="Layanan"
                  :rules="isGantiTalentMode ? 'required' : ''"
                >
                  <v-select
                    v-model="form.newService"
                    :options="listSkills"
                    label="name"
                    placeholder="Pilih Layanan"
                    @input="() => {
                      form.newTalent = null
                      listTalent = []
                    }"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </ValidationProvider>
              </BFormGroup>
            </div>

            <!-- GANTI PARTNER Row: Side by side Nama Talent & Layanan -->
            <div
              v-if="isGantiPartnerMode"
              class="flex gap-[.75rem]"
            >
              <BFormGroup class="text-black font-medium w-full mb-0">
                <template #label>
                  Nama Talent
                </template>
                <BFormInput
                  v-model="form.talentName"
                  :disabled="true"
                />
              </BFormGroup>
              <BFormGroup class="text-black font-medium w-full mb-0">
                <template #label>
                  Layanan
                </template>
                <BFormInput
                  v-model="form.serviceName"
                  :disabled="true"
                />
              </BFormGroup>
            </div>

            <!-- Common field: Pilih Talent Lead -->
            <BFormGroup class="text-black font-medium">
              <template #label>
                Pilih Talent Lead<span class="text-danger">*</span>
              </template>
              <ValidationProvider
                #default="{ errors }"
                name="Pilih Talent Lead"
                rules="required"
              >
                <v-select
                  v-model="form.talentLead"
                  label="name"
                  :options="listLeader"
                  :loading="isLoadingLeads"
                  placeholder="Pilih Talent Lead"
                  @search="(search) => search.length > 0 ? onSearchLeader(search) : ''"
                />
                <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
              </ValidationProvider>
            </BFormGroup>

            <!-- Common field: Kantor -->
            <BFormGroup class="text-black font-medium">
              <template #label>
                Kantor<span class="text-danger">*</span>
              </template>
              <ValidationProvider
                #default="{ errors }"
                name="Kantor"
                rules="required"
              >
                <v-select
                  v-model="form.office"
                  label="working_space_name"
                  :options="listOffice"
                  :loading="isLoadingOffices"
                  placeholder="Pilih Kantor"
                />
                <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
              </ValidationProvider>
            </BFormGroup>

            <!-- Common field: Device -->
            <BFormGroup class="text-black font-medium">
              <template #label>
                Device<span class="text-danger">*</span>
              </template>
              <ValidationProvider
                #default="{ errors }"
                name="Device"
                rules="required"
              >
                <v-select
                  v-model="form.device"
                  label="device_name"
                  :options="listDevice"
                  :loading="isLoadingDevices"
                  placeholder="Pilih Device"
                />
                <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
              </ValidationProvider>
            </BFormGroup>

            <!-- Common field: Dates side by side -->
            <div class="flex gap-[.75rem]">
              <BFormGroup class="text-black font-medium w-full">
                <template #label>
                  Tanggal Ditetapkan<span class="text-danger">*</span>
                </template>
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  name="Tanggal Ditetapkan"
                  class="w-full"
                >
                  <input
                    v-model="form.legitAt"
                    type="date"
                    class="form-control w-full"
                    placeholder="dd/mm/yyyy"
                  >
                  <span
                    v-if="errors.length"
                    class="text-danger d-block mt-[2px] text-sm font-normal"
                  >
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </BFormGroup>

              <BFormGroup class="text-black font-medium w-full">
                <template #label>
                  Tanggal Berlaku<span class="text-danger">*</span>
                </template>
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  name="Tanggal Berlaku"
                  class="w-full"
                >
                  <input
                    v-model="form.applyAt"
                    type="date"
                    class="form-control w-full"
                    placeholder="dd/mm/yyyy"
                  >
                  <span
                    v-if="errors.length"
                    class="text-danger d-block mt-[2px] text-sm font-normal"
                  >
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </BFormGroup>
            </div>
          </div>

          <!-- Form Insentif Talent section (shown when service is Admin Marketplace) -->
          <div
            v-show="isAdminMarketplace && isGantiTalentMode"
            class="mt-[2rem]"
          >
            <p class="font-semibold text-lg text-black mb-[1rem]">
              Form Insentif Talent
            </p>
            <div>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Gaji Pokok<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Gaji Pokok"
                  :rules="isAdminMarketplace ? 'required|integer|min_value:0' : ''"
                >
                  <b-form-input
                    v-model.number="incentive.base_salary"
                    number
                    placeholder="Masukkan nominal"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <div class="[&_legend]:text-[#4A5565] [&_legend]:ml-[16px] [&_legend]:truncate [&_legend]:!max-w-[120px]">
                <div class="text-[#0A0A0A] font-medium text-[14px] mb-[12px]">
                  Performa Chat<span class="text-danger">*</span>
                </div>
                <b-form-group
                  label-cols="4"
                  class="!mb-[12px]"
                >
                  <template #label>
                    Rate >95%
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Rate >95%"
                    :rules="isAdminMarketplace ? 'required|integer|min_value:0' : ''"
                  >
                    <b-form-input
                      v-model.number="incentive.chat_rate_high"
                      number
                      placeholder="Masukkan nominal"
                    />
                    <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  label-cols="4"
                  class="!mb-[12px]"
                >
                  <template #label>
                    Rate 85%-95%
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Rate 85%-95%"
                    :rules="isAdminMarketplace ? 'required|integer|min_value:0' : ''"
                  >
                    <b-form-input
                      v-model.number="incentive.chat_rate_mid"
                      number
                      placeholder="Masukkan nominal"
                    />
                    <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group label-cols="4">
                  <template #label>
                    Rate &lt;85%
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Rate <85%"
                    :rules="isAdminMarketplace ? 'required|integer|min_value:0' : ''"
                  >
                    <b-form-input
                      v-model.number="incentive.chat_rate_low"
                      number
                      placeholder="Masukkan nominal"
                    />
                    <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
              <div class="mb-[16px]">
                <div class="text-[#0A0A0A] font-medium text-[14px] mb-[12px]">
                  Update postingan (Feeds)<span class="text-danger">*</span>
                </div>
                <div class="flex items-start gap-x-[20px] gap-y-[12px] flex-wrap w-fit max-w-[460px] md:max-w-none">
                  <div class="flex items-start gap-[12px] basis-[240px] grow">
                    <validation-provider
                      #default="{ errors }"
                      name="per post"
                      :rules="isAdminMarketplace ? 'required|integer|min_value:0' : ''"
                    >
                      <b-form-input
                        v-model.number="incentive.update_posting_rate"
                        number
                        placeholder="Masukkan nominal"
                      />
                      <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                    </validation-provider>
                    <span class="text-[#6A7282] whitespace-nowrap h-[34.55px] flex items-center">per post</span>
                  </div>
                  <div class="flex items-start gap-[12px] basis-[200px] grow">
                    <validation-provider
                      #default="{ errors }"
                      name="post/bulan (max)"
                      :rules="isAdminMarketplace ? 'required|integer|min_value:0' : ''"
                    >
                      <b-form-input
                        v-model.number="incentive.update_posting_max"
                        number
                        placeholder="0"
                      />
                      <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                    </validation-provider>
                    <span class="text-[#6A7282] whitespace-nowrap h-[34.55px] flex items-center">post/bulan (max)</span>
                  </div>
                </div>
              </div>
              <div class="mb-[16px]">
                <div class="text-[#0A0A0A] font-medium text-[14px] mb-[12px]">
                  Update Video<span class="text-danger">*</span>
                </div>
                <div class="flex items-start gap-x-[20px] gap-y-[12px] flex-wrap w-fit max-w-[460px] md:max-w-none">
                  <div class="flex items-start gap-[12px] basis-[240px] grow">
                    <validation-provider
                      #default="{ errors }"
                      name="per video"
                      :rules="isAdminMarketplace ? 'required|integer|min_value:0' : ''"
                    >
                      <b-form-input
                        v-model.number="incentive.update_video_rate"
                        number
                        placeholder="Masukkan nominal"
                      />
                      <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                    </validation-provider>
                    <span class="text-[#6A7282] whitespace-nowrap h-[34.55px] flex items-center">per video</span>
                  </div>
                  <div class="flex items-start gap-[12px] basis-[200px] grow">
                    <validation-provider
                      #default="{ errors }"
                      name="video/bulan (max)"
                      :rules="isAdminMarketplace ? 'required|integer|min_value:0' : ''"
                    >
                      <b-form-input
                        v-model.number="incentive.update_video_max"
                        number
                        placeholder="0"
                      />
                      <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                    </validation-provider>
                    <span class="text-[#6A7282] whitespace-nowrap h-[34.55px] flex items-center">video/bulan (max)</span>
                  </div>
                </div>
              </div>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Update Produk<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Update Produk"
                  :rules="isAdminMarketplace ? 'required|integer|min_value:0' : ''"
                >
                  <b-form-input
                    v-model.number="incentive.update_product_rate"
                    number
                    placeholder="Masukkan nominal"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Bonus Penjualan<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Bonus Penjualan"
                  :rules="isAdminMarketplace ? 'required|integer|min_value:0' : ''"
                >
                  <div class="flex items-center gap-[12px]">
                    <b-form-input
                      v-model.number="incentive.sales_bonus_percentage"
                      number
                      placeholder="Masukkan nominal"
                    />
                    <span class="sm:whitespace-nowrap text-[14px] text-[#6A7282]">% dari penjualan/bulan</span>
                  </div>
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Invoice<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Invoice"
                  :rules="isAdminMarketplace ? 'required|integer|min_value:0' : ''"
                >
                  <div class="flex items-center gap-[12px]">
                    <b-form-input
                      v-model.number="incentive.invoice_rate"
                      number
                      placeholder="Masukkan nominal"
                    />
                    <span class="sm:whitespace-nowrap text-[14px] text-[#6A7282]">per invoice</span>
                  </div>
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Broadcast<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Broadcast"
                  :rules="isAdminMarketplace ? 'required|integer|min_value:0' : ''"
                >
                  <div class="flex items-center gap-[12px]">
                    <b-form-input
                      v-model.number="incentive.broadcast_rate"
                      number
                      placeholder="Masukkan nominal broadcast"
                    />
                    <span class="sm:whitespace-nowrap text-[14px] text-[#6A7282]">per bulan</span>
                  </div>
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Setting Iklan<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Setting Iklan"
                  :rules="isAdminMarketplace ? 'required|integer|min_value:0' : ''"
                >
                  <div class="flex items-center gap-[12px]">
                    <b-form-input
                      v-model.number="incentive.setting_ads_rate"
                      number
                      placeholder="Masukkan nominal setting iklan"
                    />
                    <span class="sm:whitespace-nowrap text-[14px] text-[#6A7282]">per bulan</span>
                  </div>
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group class="text-black font-medium">
                <template #label>
                  Setting Affiliate<span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Setting Affiliate"
                  :rules="isAdminMarketplace ? 'required|integer|min_value:0' : ''"
                >
                  <b-form-input
                    v-model.number="incentive.setting_affiliate_rate"
                    number
                    placeholder="Masukkan nominal setting affiliate"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <div class="mb-[16px]">
                <div class="text-[#0A0A0A] font-medium text-[14px] mb-[12px]">
                  Lembur<span class="text-danger">*</span>
                </div>
                <div class="flex items-start gap-[12px] flex-wrap">
                  <validation-provider
                    #default="{ errors }"
                    name="overtime"
                    :rules="isAdminMarketplace ? 'required|integer|min_value:0' : ''"
                    class="basis-[200px] grow"
                  >
                    <b-form-input
                      v-model.number="incentive.overtime_rate"
                      number
                      placeholder="Masukkan nominal lembur"
                    />
                    <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                  </validation-provider>
                  <validation-provider
                    #default="{ errors }"
                    name="post/bulan (max)"
                    :rules="isAdminMarketplace ? 'required' : ''"
                    class="basis-[120px] grow sm:grow-0"
                  >
                    <v-select
                      v-model="incentive.overtime_type"
                      label="text"
                      :reduce="option => option.value"
                      :options="overtimeTypes"
                      :clearable="false"
                      class="[&_ul]:!min-w-[120px] [&>div]:h-[34.55px] [&_span]:!m-0"
                    />
                    <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Preview SK Section (shown for Ganti Partner mode or Ganti Talent mode) -->
        <section
          v-if="!invalid && (isGantiPartnerMode || isGantiTalentMode)"
          class="mb-[2rem]"
        >
          <p class="mb-[.5rem] font-semibold text-lg text-black">
            Preview SK
          </p>
          <PreviewSK :data="previewSKData" />
        </section>

        <!-- Footer Action Buttons -->
        <div class="flex gap-[.75rem] pt-[1rem] border-t border-[#E5E5E5]">
          <BButton
            variant="light"
            block
            class="py-2.5 rounded-xl font-medium"
            @click="onClose"
          >
            Batalkan
          </BButton>
          <BButton
            variant="primary"
            block
            :disabled="invalid || loadingSubmit"
            class="mt-0! bg-[#EC5A24] border-0 py-2.5 rounded-xl font-medium"
            @click="handleSubmit"
          >
            <BSpinner
              v-if="loadingSubmit"
              small
            />
            <span v-else>Generate SK</span>
          </BButton>
        </div>
      </ValidationObserver>
    </div>
  </b-sidebar>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import VSelect from 'vue-select'
import '@core/scss/vue/libs/vue-select.scss'
import { komtimAxiosIns } from '@/libs/axios'
import { YEAR_MONTH_DAY } from '@/libs/filterDate'
import {
  CHURN_ACTION, showSuccess, showError, DEFAULT_INCENTIVE,
} from '../config'
import PreviewSK from './templates/PreviewSK.vue'

export default {
  name: 'ChurnDrawer',
  components: {
    ValidationObserver,
    ValidationProvider,
    VSelect,
    PreviewSK,
  },
  props: {
    drawer: {
      type: Object,
      default: () => ({
        visible: false,
        id: 'churn-drawer',
        title: '',
        data: () => ({}),
      }),
    },
  },
  data() {
    return {
      required,
      loadingSubmit: false,
      isLoadingTalents: false,
      isLoadingPartners: false,
      isLoadingLeads: false,
      isLoadingDevices: false,
      isLoadingOffices: false,

      listTalent: [],
      listPartner: [],
      listLeader: [],
      listDevice: [],
      listOffice: [],
      listSkills: [],

      form: {
        initialPartnerName: '',
        newPartner: null,
        talentName: '',
        serviceName: '',
        newTalent: null,
        newService: null,
        talentLead: null,
        office: null,
        device: null,
        legitAt: '',
        applyAt: '',
      },
      incentive: { ...DEFAULT_INCENTIVE },
      overtimeTypes: [
        { text: 'per jam', value: 'hourly' },
        { text: 'per hari', value: 'daily' },
      ],
    }
  },
  computed: {
    drawerTitle() {
      return this.drawer.title || ''
    },
    isGantiTalentMode() {
      return this.drawer.title === CHURN_ACTION.EDIT_TALENT
    },
    isGantiPartnerMode() {
      return this.drawer.title === CHURN_ACTION.EDIT_PARTNER
    },
    isAdminMarketplace() {
      const selectedServiceName = this.form.newService?.name || this.form.serviceName
      return selectedServiceName === 'Admin Marketplace'
    },
    previewSKData() {
      const actionSource = this.drawer.title
      let tableItems = []
      if (this.isGantiTalentMode) {
        tableItems = [
          [
            this.drawer.data.partner.name,
            this.drawer.data.partner.id,
            this.form.talentName,
            this.form.newTalent?.full_name,
            this.form.talentLead?.name,
          ],
        ]
      } else if (this.isGantiPartnerMode) {
        tableItems = [
          [
            this.form.talentName,
            this.drawer.data.talent.id,
            this.form.initialPartnerName,
            this.form.newPartner?.name,
            this.form.talentLead?.name,
          ],
        ]
      }
      return { actionSource, tableItems }
    },
  },
  methods: {
    onClose() {
      this.resetForm()
      this.$emit('on-close')
    },
    handleDrawerShown() {
      this.getListOffice()
      this.getListSkills()
      this.getListDevice()
      if (this.drawer.data) {
        if (this.drawer.data.partner_name) {
          this.form.initialPartnerName = this.drawer.data.partner_name
        }
        if (this.drawer.data.talent_name) {
          this.form.talentName = this.drawer.data.talent_name
        }
        if (this.drawer.data.skill_name) {
          this.form.serviceName = this.drawer.data.skill_name
        }
        if (this.drawer.data.incentive) {
          this.incentive = { ...DEFAULT_INCENTIVE, ...this.drawer.data.incentive }
        }
      }
      if (!this.form.legitAt) {
        this.form.legitAt = YEAR_MONTH_DAY()
      }
    },
    resetForm() {
      this.form = {
        initialPartnerName: '',
        newPartner: null,
        talentName: '',
        serviceName: '',
        newTalent: null,
        newService: null,
        talentLead: null,
        office: null,
        device: null,
        legitAt: '',
        applyAt: '',
      }
      this.incentive = { ...DEFAULT_INCENTIVE }
      this.$nextTick(() => {
        if (this.$refs.formObserver) {
          this.$refs.formObserver.reset()
        }
      })
    },
    async handleSwitchTalent() {
      try {
        this.loadingSubmit = true
        const payload = {
          partner_assignment_request_id: this.drawer.data?.id || 0,
          new_talent_id: this.form.newTalent?.id || 0,
          talent_lead_id: this.form.talentLead?.id || 0,
          office_id: this.form.office?.id || 0,
          device_id: this.form.device?.id || 0,
          start_date: this.form.applyAt ? YEAR_MONTH_DAY(this.form.applyAt) : '',
          published_date: this.form.legitAt ? YEAR_MONTH_DAY(this.form.legitAt) : '',
        }

        await komtimAxiosIns.put(`/v1/partner_assignments/${this.drawer.data?.sk_partner_assignment_id || 0}/talent`, payload)
        showSuccess({ title: 'SK Berhasil Dibuat!' })
        this.$emit('on-success')
        this.onClose()
      } catch (err) {
        showError({ title: 'SK Gagal Dibuat!' })
      } finally {
        this.loadingSubmit = false
      }
    },
    async handleSwitchPartner() {
      try {
        this.loadingSubmit = true
        const payload = {
          partner_assignment_request_id: this.drawer.data?.id || 0,
          new_partner_id: this.form.newPartner?.id || 0,
          talent_lead_id: this.form.talentLead?.id || 0,
          office_id: this.form.office?.id || 0,
          device_id: this.form.device?.id || 0,
          start_date: this.form.applyAt ? YEAR_MONTH_DAY(this.form.applyAt) : '',
          published_date: this.form.legitAt ? YEAR_MONTH_DAY(this.form.legitAt) : '',
        }
        await komtimAxiosIns.put(`/v1/partner_assignments/${this.drawer.data?.sk_partner_assignment_id || 0}/partner`, payload)
        showSuccess({ title: 'SK Berhasil Dibuat!' })
        this.$emit('on-success')
        this.onClose()
      } catch (err) {
        showError({ title: 'SK Gagal Dibuat!' })
      } finally {
        this.loadingSubmit = false
      }
    },
    handleSubmit() {
      if (this.isGantiPartnerMode) {
        this.handleSwitchPartner()
      } else if (this.isGantiTalentMode) {
        this.handleSwitchTalent()
      }
    },
    async getListTalent(keyword) {
      this.isLoadingTalents = true
      try {
        const url = `v1/talents?offset=0&limit=20&keyword=${keyword}`
        const res = await komtimAxiosIns.get(url)
        this.listTalent = this.form.newService?.id ? res.data?.data.filter(item => item.skill_id === this.form.newService?.id) : []
      } catch {
        showError({ title: 'Terjadi Kesalahan!' })
      } finally {
        this.isLoadingTalents = false
      }
    },
    onSearchTalent(search) {
      this.getListTalent(search)
    },
    async getListPartner(keyword) {
      this.isLoadingPartners = true
      try {
        const url = `v1/partners?offset=0&limit=20&keyword=${keyword}`
        const res = await komtimAxiosIns.get(url)
        this.listPartner = res.data?.data || []
      } catch {
        showError({ title: 'Terjadi Kesalahan!' })
      } finally {
        this.isLoadingPartners = false
      }
    },
    onSearchPartner(search) {
      this.getListPartner(search)
    },
    async getListLeader(keyword) {
      this.isLoadingLeads = true
      try {
        const url = `v1/staffs?offset=0&limit=20&keyword=${keyword}`
        const res = await komtimAxiosIns.get(url)
        this.listLeader = res.data?.data || []
      } catch {
        showError({ title: 'Terjadi Kesalahan!' })
      } finally {
        this.isLoadingLeads = false
      }
    },
    onSearchLeader(search) {
      this.getListLeader(search)
    },
    async getListOffice() {
      this.isLoadingOffices = true
      try {
        const url = 'v1/working_spaces/resource?status=true'
        const res = await komtimAxiosIns.get(url)
        this.listOffice = res.data?.data || []
      } catch {
        showError({ title: 'Terjadi Kesalahan!' })
      } finally {
        this.isLoadingOffices = false
      }
    },
    async getListDevice() {
      this.isLoadingDevices = true
      try {
        const params = new URLSearchParams({
          offset: '0',
          limit: '20',
          holder_name: 'IT Support',
        })

        const partnerId = this.form.newPartner?.no_partner || this.drawer.data?.partner?.no_partner
        params.append('partner_id', partnerId)

        const url = `v1/devices?${params.toString()}`
        const res = await komtimAxiosIns.get(url)
        this.listDevice = res.data?.data || []
      } catch {
        showError({ title: 'Terjadi Kesalahan!' })
      } finally {
        this.isLoadingDevices = false
      }
    },
    async getListSkills() {
      try {
        const url = 'v1/skills/resource?active=true'
        const res = await komtimAxiosIns.get(url)
        this.listSkills = res.data?.data || []
      } catch {
        showError({ title: 'Terjadi Kesalahan!' })
      }
    },
  },
}
</script>

<style scoped>
.btn-primary {
  background-color: #EC5A24 !important;
  border-color: #EC5A24 !important;
  border-radius: 10px;
}

.btn-light {
  border-radius: 10px;
}

::v-deep .vs--disabled .vs__dropdown-toggle {
  background-color: #efefef;
  border-color: #d8d6de;
  color: #6f6b7d;
}

::v-deep .vs--disabled .vs__search {
  cursor: default !important;
}
</style>
